import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Claim } from '@wsphere/warranties/domain';
import { firstValueFrom, map } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ClaimResolutionOptionsService {
  private http = inject(HttpClient);

  async listOptions() {
    return firstValueFrom(
      this.http
        .get<Claim.RetrieveClaimResolutionOptionsResponse>(`/api/claim-resolution-options`)
        .pipe(map(response => response.values ?? []))
    );
  }

  async updateOptions(data: Claim.UpdateClaimResolutionOptionsRequest) {
    return firstValueFrom(
      this.http.patch<Claim.UpdateClaimResolutionOptionsResponse>(`/api/claim-resolution-options`, data)
    );
  }
}
